/**
 * Scheduling view - Phase 1 placeholder.
 *
 * Real slot recommendation logic, four appointment cards, and the cascade
 * animation land in Phase 2 per HTML-BEHAVIORAL-EXTRACTION §4.5.
 */
export function Scheduling() {
  return (
    <section
      aria-labelledby="view-title-sched"
      className="px-gutter-lg py-gutter-xl"
    >
      <h2
        id="view-title-sched"
        className="text-signal-2xl font-semibold text-text-primary"
      >
        Scheduling
      </h2>
      <p className="mt-gutter-md max-w-2xl text-signal-base text-text-secondary">
        Slot recommendation surface. Phase 2 wires the four-appointment
        cascade plus deterministic fixture replay.
      </p>
      <p className="mt-gutter-sm text-signal-sm text-text-tertiary">
        [PLANNED] Phase 2 ticket.
      </p>
    </section>
  );
}
